module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 27
// module chunks = 0 1